import { getFormattedCurrency } from "../../../shared/utils/Global";
import { snakeToTitle } from "../../../shared/utils/TextUtil";
import { getFormattedDate, objectKeys } from "../../../shared/utils/DateUtil";

// LoanDetailsAttributes
export function getLoanDetailFormattedSectionData(
  details: any,
  pageConfig: any,
  sourceEntityID = "",
  userID = "",
  defaultConfig: any,
  loanDetailField: any
) {
  /* The hidden keys are the keys defined in the page config  + the keys defined in default config (globally hidden fields)
   * - the keys defined in showKeys (keys specific to platforms)
   */

  let LOAN_DETAIL_FIELDS = loanDetailField;

  const hiddenKeys = [
    ...(pageConfig?.hideKeys ?? []),
    ...(defaultConfig?.hideKeys ?? []),
  ].filter((key) => !(pageConfig?.showKeys ?? []).includes(key));

  const items = objectKeys(LOAN_DETAIL_FIELDS)
    ?.filter((key) => !hiddenKeys.includes(key))
    ?.map((key: any) => {
      let itemValue = details[key];
      const itemMeta = LOAN_DETAIL_FIELDS[key];
      if (["createdAt", "updatedAt"].includes(key)) {
        return {
          name: itemMeta.label,
          value: getFormattedDate(itemValue) || "-",
          key,
          category: itemMeta.category,
        };
      }
      if (["cibil", "experian", "cibilHardPull"].includes(key)) {
        const bureauData = details.bureauScores?.find(
          (b: any) =>
            b.bureauName === key.toUpperCase() ||
            b.bureauName === LOAN_DETAIL_FIELDS?.[key]?.key
        );

        if (bureauData) {
          return {
            key: key,
            category: itemMeta.category,
            name: LOAN_DETAIL_FIELDS?.[key]?.label ?? "",
            value: bureauData?.bureauScore > 0 ? bureauData?.bureauScore : 0,
          };
        }
      }

      if (key === "fis") {
        return {
          key,
          name: "FIS Score",
          category: itemMeta.category,
          value: details?.fisScore > 0 ? details?.fisScore : 0,
        };
      }

      if (key === "assistedBy") {
        return {
          key,
          name: "Assisted By",
          category: itemMeta.category,
          value: details?.assistedBy || "",
        };
      }

      if (["cibilStatus", "experianStatus"].includes(key)) {
        const bureauData = details.bureauScores?.find(
          (b: any) => b.bureauName === key.replace(/Status/g, "").toUpperCase()
        );
        if (bureauData) {
          return {
            name: LOAN_DETAIL_FIELDS?.[key]?.label ?? "",
            value: snakeToTitle(bureauData.bureauStatus),
            key: key,
            category: itemMeta.category,
          };
        }
      }

      if (key === "loanType") {
        itemValue = snakeToTitle(itemValue);
      }

      if (key === "customerID" && userID && sourceEntityID) {
        itemValue = (
          <a
            className="underline underline-offset-2 text-indigo-700"
            href={`/leads/details/${sourceEntityID}/${userID}`}
          >
            {itemValue}
          </a>
        );
      }

      if (key === "reqLoanAmount") {
        itemValue = details.reqLoanAmount
          ? getFormattedCurrency(details.reqLoanAmount)
          : "";
      }

      if (key === "processingFee") {
        itemValue = details.processingFee
          ? getFormattedCurrency(details.processingFee)
          : 0;
      }

      return {
        name: itemMeta.label,
        value: itemValue || "-",
        key,
        category: itemMeta.category,
      };
    });

  const data: any = {};
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const categoryData = data?.[item.category] || [];
    categoryData.push(item);
    data[item.category] = categoryData;
  }

  return data;
}
